(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header') || this.parentElement;
      if (!this.header) return;

      const stickyType = this.getAttribute('data-sticky-type');
      this.alwaysSticky = stickyType === 'always';
      this.preventReveal = false;

      this.onScroll = this.onScroll.bind(this);
      this.recalc = this.recalc.bind(this);
      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

      this.recalc();
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScroll, false);
      window.addEventListener('resize', this.recalc);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.recalc);
    }

    recalc() {
      // Vị trí gốc của header trong document → khi scrollY chạm mốc này, top header = 0 (bắt đầu dính)
      this.stuckAt = this.header.offsetTop;
      // Mốc = đáy header (đã cuộn qua hết chiều cao header hay chưa)
      this.minScrollY = this.header.offsetTop + this.header.offsetHeight;
      this.lastScrollY = Math.max(this.lastScrollY || 0, this.minScrollY);
    }

    onScroll() {
      const currentScrollY = window.scrollY;

      // Header bắt đầu dính khi top header = 0
      this.header.classList.toggle('is-stuck', currentScrollY > this.stuckAt);

      // Không ẩn khi ô tìm kiếm đang focus hoặc đang có nội dung
      const searchInput = this.header.querySelector('input[type="search"]');
      const searchActive = searchInput && (searchInput === document.activeElement || searchInput.value.trim() !== '');

      if (this.alwaysSticky || currentScrollY < this.minScrollY) {
        // Luôn-sticky, hoặc chưa cuộn qua đáy header → luôn hiện
        this.header.classList.remove('header-hidden');
      } else if (currentScrollY > this.lastScrollY && !searchActive) {
        // Cuộn xuống → ẩn
        this.header.classList.add('header-hidden');
      } else if (!this.preventReveal) {
        // Cuộn lên → hiện lại
        this.header.classList.remove('header-hidden');
      } else {
        // preventReveal đang bật (vd: media gallery) → giữ ẩn, hẹn giờ gỡ cờ
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this.header.classList.add('header-hidden');
      }

      this.lastScrollY = Math.max(currentScrollY, this.minScrollY);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  function syncHeaderMainHeight() {
    document.querySelectorAll('.section-header').forEach(function (section) {
      var main = section.querySelector('.header__main');
      if (!main) return;
      section.style.setProperty('--header-main-height', main.offsetHeight + 'px');
    });
  }
  syncHeaderMainHeight();
  window.addEventListener('resize', syncHeaderMainHeight);
  window.addEventListener('load', syncHeaderMainHeight);

  document.querySelectorAll('.header__nav-bar').forEach(function (nav, navIndex) {
    var scroller = nav.querySelector(':scope > .header__nav-inner');
    if (!scroller) return;

    var activeEntry = null;
    var closeTimer = null;

    nav.querySelectorAll('.header__nav-item').forEach(function (item, itemIndex) {
      var panel = item.querySelector(':scope > .header__dropdown, :scope > .header__mega');
      if (!panel) return;

      var trigger = item.querySelector(':scope > .header__nav-link');
      var panelId = 'header-menu-panel-' + navIndex + '-' + itemIndex;
      panel.id = panel.id || panelId;

      if (trigger) {
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-controls', panel.id);
      }

      var entry = { item: item, panel: panel, trigger: trigger };

      nav.appendChild(panel);

      item.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
        openMenu(entry);
      });
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', function () { openMenu(entry); });

      panel.addEventListener('mouseenter', function () {
        window.clearTimeout(closeTimer);
      });
      panel.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeMenu(entry);
          if (trigger) trigger.focus();
        }
      });
    });

    function positionPanel(entry) {
      if (entry.panel.classList.contains('header__mega')) return;

      var navRect = nav.getBoundingClientRect();
      var itemRect = entry.item.getBoundingClientRect();

      entry.panel.style.left = '0px';
      var panelRect = entry.panel.getBoundingClientRect();
      var targetViewportLeft = Math.min(
        Math.max(itemRect.left, navRect.left),
        Math.max(navRect.left, navRect.right - panelRect.width)
      );
      var scaleX = nav.offsetWidth ? navRect.width / nav.offsetWidth : 1;
      var correctedLeft = (targetViewportLeft - panelRect.left) / (scaleX || 1);

      entry.panel.style.left = correctedLeft + 'px';
    }

    function openMenu(entry) {
      window.clearTimeout(closeTimer);
      if (activeEntry && activeEntry !== entry) closeMenu(activeEntry);

      positionPanel(entry);
      entry.item.classList.add('is-menu-open');
      entry.panel.classList.add('is-open');
      if (entry.trigger) entry.trigger.setAttribute('aria-expanded', 'true');
      activeEntry = entry;
    }

    function closeMenu(entry) {
      if (!entry) return;
      entry.item.classList.remove('is-menu-open');
      entry.panel.classList.remove('is-open');
      if (entry.trigger) entry.trigger.setAttribute('aria-expanded', 'false');
      if (activeEntry === entry) activeEntry = null;
    }

    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () { closeMenu(activeEntry); }, 120);
    }

    scroller.addEventListener('scroll', function () {
      if (activeEntry) positionPanel(activeEntry);
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (activeEntry) positionPanel(activeEntry);
    });

    nav.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (activeEntry && !activeEntry.item.contains(document.activeElement) && !activeEntry.panel.contains(document.activeElement)) {
          closeMenu(activeEntry);
        }
      });
    });
  });

  // Mega menu: category hover shows sub-items
  document.querySelectorAll('.header__mega').forEach(function (mega) {
    var cats = Array.from(mega.querySelectorAll('.header__mega-cat'));
    var groups = Array.from(mega.querySelectorAll('.header__mega-sub-group'));

    cats.forEach(function (cat) {
      cat.addEventListener('mouseenter', function () {
        var idx = cat.dataset.cat;
        cats.forEach(function (c) { c.classList.remove('is-active'); });
        groups.forEach(function (g) { g.classList.remove('is-active'); });
        cat.classList.add('is-active');
        var group = mega.querySelector('.header__mega-sub-group[data-cat="' + idx + '"]');
        if (group) group.classList.add('is-active');
      });
    });
  });
  // Mobile mega drawer: multi-expand (uses div[role=button] to avoid Dawn's button close handler)
  function mmdToggle(btn) {
    var section = btn.closest('.mmd__cat-section');
    var isOpen = section.classList.contains('is-open');
    if (isOpen) {
      section.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      section.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
  }
  document.querySelectorAll('.mmd__cat-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () { mmdToggle(btn); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); mmdToggle(btn); }
    });
  });
  // Auto-open first section on load
  document.querySelectorAll('.mmd__body').forEach(function (body) {
    var first = body.querySelector('.mmd__cat-section');
    if (first) {
      first.classList.add('is-open');
      var toggle = first.querySelector('.mmd__cat-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
  });

  // Mobile search toggle
  var mobileSearchToggle = document.querySelector('.header__mobile-search-toggle');
  var mobileSearchPanel = document.getElementById('header-mobile-search');
  if (mobileSearchToggle && mobileSearchPanel) {
    mobileSearchToggle.addEventListener('click', function () {
      var isOpen = mobileSearchPanel.classList.toggle('is-open');
      mobileSearchToggle.setAttribute('aria-expanded', String(isOpen));
      if (isOpen) mobileSearchPanel.querySelector('input[type="search"]').focus();
    });
  }

  // Mobile drawer: clicking parent menu text navigates; clicking arrow opens submenu
  document.querySelectorAll('.menu-drawer__menu details').forEach(function (det) {
    var sum = det.querySelector(':scope > summary');
    if (!sum) return;
    sum.addEventListener('click', function (e) {
      var a = e.target.closest('.menu-drawer__parent-link');
      if (a) {
        e.preventDefault();
        markLinkBusy(a);
        window.location.href = a.href;
      }
    });
  });

  // Closing the drawer the moment a link is tapped left the reader looking at the page they were
  // already on, unchanged, for as long as the next one took to arrive — nothing on screen said the
  // tap had registered. The drawer stays put instead and the tapped link says it is working, right
  // where the finger just was. Whatever loads next replaces all of it.
  var navTimer = null;
  function markLinkBusy(a) {
    if (!a) return;
    a.setAttribute('aria-busy', 'true');
    // Mark the row as well, not just the anchor. A top-level link sits inside the <summary> that
    // makes up its row, and dimming that summary dims the anchor with it — the one row meant to stay
    // lit went down with the rest.
    var row = a.closest('.menu-drawer__menu-item, .menu-drawer__phone-row, .list-social__item');
    if (row && row !== a) row.setAttribute('aria-busy', 'true');
    var drawer = document.getElementById('menu-drawer');
    if (drawer) drawer.classList.add('is-navigating');
    // If the navigation never happens — dead connection, a download, a blocked scheme — hand the
    // menu back rather than leaving it frozen mid-tap.
    clearTimeout(navTimer);
    navTimer = setTimeout(clearLinkBusy, 10000);
  }
  function clearLinkBusy() {
    clearTimeout(navTimer);
    var drawer = document.getElementById('menu-drawer');
    if (drawer) drawer.classList.remove('is-navigating');
    document.querySelectorAll('#menu-drawer [aria-busy="true"]').forEach(function (el) {
      el.removeAttribute('aria-busy');
    });
  }
  // Rather than trying to name every link that will not navigate, turn the condition around: if the
  // reader can still see this page, then "leaving" is no longer true and the state is stale. That
  // covers the back button restoring the page from cache, a phone dialog being dismissed, a trip out
  // to another app and back — including whatever else has the same shape and has not come up yet.
  window.addEventListener('pageshow', function (e) {
    clearLinkBusy();
    // A restored page is one the reader already left. Safari brings it back exactly as it was —
    // <details open>, aria-expanded='true' and the dark scrim that attribute drives still covering
    // the page — so the menu has to be shut as well, not merely un-dimmed. Closing on the way out
    // used to do this incidentally; now that the drawer stays up during navigation, it has to be
    // done here.
    if (e.persisted) closeMobileDrawer();
  });
  window.addEventListener('focus', clearLinkBusy);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) clearLinkBusy();
  });

  // Close the mobile drawer instantly so a slow page load never leaves it open + blank.
  function closeMobileDrawer() {
    var hd = document.querySelector('header-drawer');
    if (!hd) return;
    var details = hd.querySelector('details');
    if (details) {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
    }
    // aria-expanded='true' on the summary drives the full-page dark overlay (base.css) — reset it too.
    hd.querySelectorAll('summary[aria-expanded="true"]').forEach(function (s) {
      s.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('overflow-hidden-' + (hd.dataset.breakpoint || 'tablet'));
    var header = document.querySelector('.section-header');
    if (header) header.classList.remove('menu-open');
  }

  // Any navigating link inside the drawer (plain items, sub-links, promo cards, phone) closes it on click.
  var menuDrawerEl = document.getElementById('menu-drawer');
  if (menuDrawerEl) {
    menuDrawerEl.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return; // accordions / non-navigating links
      // Nothing to wait on: these hand off to another app or another tab and leave this page exactly
      // where it is. A tel: link that the reader then cancels is the one that gave this away — the
      // menu sat greyed out with no navigation ever coming to replace it.
      if (a.target === '_blank' || a.hasAttribute('download')) return;
      if (/^(tel|mailto|sms|facetime|whatsapp):/i.test(href)) return;
      markLinkBusy(a);
    });
  }

  (function () {
    var lastDarkState = null;

    function checkDarkMode() {
      var headerMain = document.querySelector('.header__main');

      if (!headerMain) return;

      var bg = window.getComputedStyle(headerMain).backgroundColor;

      var match = bg.match(/\d+/g);

      if (!match || match.length < 3) return;

      var r = parseInt(match[0], 10);
      var g = parseInt(match[1], 10);
      var b = parseInt(match[2], 10);

      var luminance =
        (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      var isDark = luminance < 0.5;

      if (isDark !== lastDarkState) {
        document.documentElement.classList.toggle(
          'is-dark',
          isDark
        );

        lastDarkState = isDark;
      }
    }

    checkDarkMode();
    requestAnimationFrame(checkDarkMode);
    window.addEventListener('load', checkDarkMode);
    
    setInterval(checkDarkMode, 500);
  })();

  function checkOperatingStatus() {
    var statusEls = document.querySelectorAll('.header__status[data-store-schedule]');
    if (!statusEls.length) return;

    var firstEl = statusEls[0];
    var raw = firstEl.getAttribute('data-store-schedule');
    if (!raw) return;

    var schedule = null;
    try { schedule = JSON.parse(raw); } catch(e) {}
    if (!schedule || !schedule.timezone) return;

    var scheduleHash = schedule.timezone + '_' + schedule.mf.open + '_' + schedule.mf.close + '_' + schedule.sat.open + '_' + schedule.sat.close + '_' + schedule.sun.open + '_' + schedule.sun.close;
    var key = '4s_op_' + scheduleHash;
    var nowMs = Date.now();
    var isOpen = true;
    var cached = null;

    try { cached = JSON.parse(localStorage.getItem(key) || 'null'); } catch(e) {}

    if (cached && typeof cached.isOpen === 'boolean' && cached.expireAt && nowMs < cached.expireAt) {
      isOpen = cached.isOpen;
    } else {
      try {
        var now = new Date();
        var formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: schedule.timezone,
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false
        });

        var weekday = '', hour = 0, minute = 0, second = 0;
        formatter.formatToParts(now).forEach(function (p) {
          if (p.type === 'weekday') weekday = p.value;
          if (p.type === 'hour') hour = parseInt(p.value, 10);
          if (p.type === 'minute') minute = parseInt(p.value, 10);
          if (p.type === 'second') second = parseInt(p.value, 10);
        });

        if (hour === 24) hour = 0;
        var currentTimeInHours = hour + (minute / 60) + (second / 3600);

        var daysOrder = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var currentDayIdx = daysOrder.indexOf(weekday);

        function getSchedule(d) {
          if (['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(d) !== -1) return schedule.mf;
          if (d === 'Sat') return schedule.sat;
          if (d === 'Sun') return schedule.sun;
          return null;
        }

        var daySchedule = getSchedule(weekday);
        var hoursUntilNextChange = 24;

        if (daySchedule && currentTimeInHours >= daySchedule.open && currentTimeInHours < daySchedule.close) {
          isOpen = true;
          hoursUntilNextChange = daySchedule.close - currentTimeInHours;
        } else if (daySchedule && currentTimeInHours < daySchedule.open) {
          isOpen = false;
          hoursUntilNextChange = daySchedule.open - currentTimeInHours;
        } else {
          isOpen = false;
          var nextDay = daysOrder[(currentDayIdx + 1) % 7];
          var nextSch = getSchedule(nextDay);
          var nextOpen = nextSch ? nextSch.open : 8;
          hoursUntilNextChange = (24 - currentTimeInHours) + nextOpen;
        }

        var expireAt = nowMs + Math.max(1, Math.floor(hoursUntilNextChange * 3600 * 1000));
        localStorage.setItem(key, JSON.stringify({ isOpen: isOpen, expireAt: expireAt }));
      } catch (err) {
        console.error('Error evaluating store operating status:', err);
      }
    }

    if (isOpen) {
      document.documentElement.classList.remove('store-closed');
    } else {
      document.documentElement.classList.add('store-closed');
    }

    statusEls.forEach(function (el) {
      var parentRow = el.closest('.header__phone-row');
      if (isOpen) {
        el.style.display = '';
        if (parentRow) parentRow.classList.remove('is-closed');
      } else {
        el.style.display = 'none';
        if (parentRow) parentRow.classList.add('is-closed');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkOperatingStatus);
  } else {
    checkOperatingStatus();
  }

  } catch(e) { console.error(e); }
})();
})();
